module.exports = __webpack_public_path__ + "static/media/start.c3ba2fff.svg";